import React from 'react'
import img2022 from '../components/images/amazonglobal.png'
const events = () => {
    return (

        <>
            <div className='container'>
                <div className="row  m-2">
                    <img src={img2022} alt='amazonglobal' />
                </div>
                <div className="row m-2">
                    <div className="col-sm ">

                        <h2 className='p-2'>Expand Your Horizons with E Seller Support, Your Amazon Global Affiliate Partner
                        </h2>
                        <p>As an Amazon Global Affiliate Partner, E Seller Support brings you unparalleled expertise and support in expanding your business internationally on Amazon’s diverse marketplaces. Our comprehensive services, from global account management to international logistics and compliance, ensure that your business reaches its full potential across the globe. With our specialized knowledge and Amazon-backed strategies, we enable you to navigate the complexities of global e-commerce smoothly and effectively, elevating your success on a worldwide scale. Trust E Seller Support to deliver the results you need to excel in the dynamic and competitive international market. </p>
                    </div>
                    <div className="col-sm ">
                        {/* <img src={img201} alt='Queryimg' /> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default events